import type { AgentName, Platform } from "@/landing/system/marks";

/**
 * The product pages the nav Features menu and the footer link to, in one
 * place so they can't drift. Slugs match PLATFORM_COPY_MAP (platform-copy.ts)
 * and CLI_FEATURE_COPY_MAP (cli-feature-copy.ts).
 */
export const PLATFORM_PAGES: { label: string; slug: Platform }[] = [
  { label: "LinkedIn", slug: "linkedin" },
  { label: "Sales Navigator", slug: "sales-navigator" },
  { label: "X", slug: "x" },
  { label: "Reddit", slug: "reddit" },
];

export const AGENT_PAGES: { label: AgentName; slug: string }[] = [
  { label: "Claude Code", slug: "claude-code-for-social-media-marketing" },
  { label: "Codex", slug: "codex-for-social-media-marketing" },
  { label: "Claude", slug: "claude-for-social-media" },
  { label: "ChatGPT", slug: "chatgpt-for-social-media" },
  { label: "Cursor", slug: "cursor-for-social-media" },
  { label: "OpenClaw", slug: "openclaw-for-social-media" },
  { label: "Hermes", slug: "hermes-for-social-media" },
];

export const USE_CASE_PAGES: {
  label: string;
  slug: string;
  /** Its label in SiteCopy, so the nav and footer speak the page's language. */
  copyKey:
    | "searchProfiles"
    | "sendMessages"
    | "analyzePosts"
    | "marketingAgents"
    | "multiAccount"
    | "competitorAnalysis";
}[] = [
  {
    label: "Search profiles",
    slug: "search-profiles",
    copyKey: "searchProfiles",
  },
  { label: "Send messages", slug: "send-messages", copyKey: "sendMessages" },
  {
    label: "Analyze posts & comments",
    slug: "analyze-posts-and-comments",
    copyKey: "analyzePosts",
  },
  {
    label: "AI agents for marketing",
    slug: "ai-agents-for-marketing",
    copyKey: "marketingAgents",
  },
  {
    label: "Multi-account",
    slug: "multi-account-social-media",
    copyKey: "multiAccount",
  },
  {
    label: "Competitor analysis",
    slug: "competitor-analysis-tool",
    copyKey: "competitorAnalysis",
  },
];
